<template>
  <div class="testing_requests_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="addTestingRequest" style="padding:15px;">
            <div class="form-group">
              <label for="model">Shipping Date*</label>
              <br />
              <div
                :class="{
                  'is-invalid': $v.form.shippingDate.$invalid && submit,
                  'is-valid': !$v.form.shippingDate.$invalid && submit
                }"
              >
                <date-picker
                    input-class="form-control"
                    v-model="form.shippingDate"
                    input-name="shipping_date"
                    :first-day-of-week="1"
                    lang="en"
                    style="width: 100%"
                ></date-picker>
                <div
                    class="invalid-feedback"
                    v-if="!$v.form.shippingDate.required"
                >
                  Please provide a shipping date
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="tracking_number">Tracking Number*</label>
              <input
                :class="{
                  'is-invalid': $v.form.trackingNumber.$invalid && submit,
                  'is-valid': !$v.form.trackingNumber.$invalid && submit
                }"
                type="text"
                v-model="form.trackingNumber"
                class="form-control"
                id="tracking_number"
                name="tracking_number"
                aria-describedby="model_help"
                placeholder="i.e: abc123"
              />
              <div class="invalid-feedback">
                Please provide a tracking number
              </div>
            </div>

            <div class="form-group">
              <label for="comments">Comments</label>
              <textarea
                rows="7"
                cols="50"
                v-model="form.comments"
                class="form-control"
                id="comments"
                name="comments"
                aria-describedby="comments_help"
              ></textarea>
            </div>

            <b-btn variant="success" size="md" class="float-left" type="submit"
              >Add Testing Request</b-btn
            >
            <b-btn
              variant="default"
              size="md"
              class="float-right"
              :to="'/testing/requests/'"
              >Cancel</b-btn
            >
            <br />
            <br />
            <br />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";

export default {
  name: "testing-request-add",
  components: {
    DatePicker
  },
  data() {
    return {
      form: {
        shippingDate: "",
        trackingNumber: "",
        comments: ""
      },
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Testing Requests", to: { name: "testing-requests" } },
        { text: "Add Testing Request", active: true }
      ]
    };
  },
  validations() {
    return {
      form: {
        shippingDate: {
          required
        },
        trackingNumber: {
          required
        }
      }
    };
  },
  methods: {
    addTestingRequest() {
      this.submit = true;

      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let testingRequest = {
          shipping_date: this.form.shippingDate,
          tracking_number: this.form.trackingNumber,
          comments: this.form.comments
        };

        this.$http.post(this.APIURL + this.BRAND + "/testing/requests", testingRequest).then(
          () => {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Testing Request added successfully, taking you back to testing requests list.",
              type: "success",
              onClose: () => {
                loader.hide();
                this.$router.push({ name: "testing-requests" });
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }
};
</script>
